import {
  center,
  dynamicPx,
  em,
  flexColumn,
  flexStyle,
  TextTypography,
} from 'components/common/Common';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

const defaultFontSize = 16;

export const FlexDisplay = styled.div`
  ${flexStyle}
`;

export const SectionContainer = styled.section`
  ${flexColumn}
  position: relative;
  width: 100%;
`;

export const contentWidth = css`
  width: ${dynamicPx({ minSize: 343, maxSize: 1300 })};
  @media (max-width: 768px) {
    width: ${dynamicPx({ minSize: 304, maxSize: 1300, minVW: 320 })};
  }
`;

export const MainContainer = styled.section`
  --step-0: clamp(1em, calc(0.9em + 0.5vw), 1.5em);
  --step--1: clamp(0.83em, calc(0.76em + 0.37vw), 1.2em);
  --step--2: clamp(0.69em, calc(0.64em + 0.27vw), 0.96em);

  --main-bg-color: #fff;
  --white: #fff;
  --table-border-color: #a6c0cf;
  /* 爱瑞领航VI标准色_深蓝 */
  --primary-color: #0063db;

  --standard-top-padding: ${dynamicPx({ maxSize: 120 / 2, minSize: 56 / 2 })};
  --standard-side-padding: clamp(1em, calc(-3.46em + 19.03vw), 19.38em);

  --standard-padding: var(--standard-top-padding) var(--standard-side-padding);

  font-size: ${defaultFontSize}px;
  ${flexColumn}
  justify-content: center;
  align-items: center;
  background-color: var(--main-bg-color);
  @media (max-width: 768px) {
    margin: ${dynamicPx({ maxSize: 60, minSize: 44 })} 0;
  }
`;

export const MoreLink = styled(Link)`
  ${center}

  padding:  ${dynamicPx({ minSize: 4, maxSize: 8 })}  1em;
  cursor: pointer;
  border: 2px solid var(--primary-color);
  border-radius: 3.0625em;

  &:hover {
    background-color: var(--primary-color);
    border: 2px solid transparent;
    ${TextTypography} {
      color: var(--white) !important;
    }
  }
`;

export const BlurBackgroundName = styled.div`
  ${center}
  padding: ${dynamicPx({ maxSize: 8, minSize: 4 })} ${dynamicPx({ maxSize: 16, minSize: 8 })};
  max-width: max-content;
  background: rgba(0, 0, 0, 0.16);
  backdrop-filter: blur(6px);
  border-radius: ${dynamicPx({ minSize: 4, maxSize: 8 })};
`;

export const InfoIcon = styled.div`
  --dynamic-px: ${(props) =>
    props.$dynamicSize &&
    dynamicPx({ minSize: props.$dynamicSize.minSize, maxSize: props.$dynamicSize.maxSize })};

  width: ${(props) => (props.$dynamicSize ? `var(--dynamic-px)` : `${em(props.width)}` || '80px')};
  height: ${(props) =>
    props.$dynamicSize
      ? props.$autoHeight
        ? 'auto'
        : `var(--dynamic-px)`
      : `${em(props.height)}` || '80px'};
  cursor: ${(props) => `${props.pointer && 'pointer'}`};
`;

export const Breadcrumb = styled(FlexDisplay)`
  width: clamp(21.4375em, calc(343px + (1300 - 343) * ((100vw - 375px) / (1920 - 375))), 81.25em);
  max-width: 1300px;
  align-items: center;
  margin-top: ${dynamicPx({ maxSize: 40, minSize: 16 })};
  ${flexGap('0.25em')}
`;

export const CenterContent = styled.article`
  ${flexColumn}
  ${flexGap('1em')}
  text-align: center;
  align-items: center;
`;

export const ThreeDTitle = styled.h1`
  --dynamic-px: ${(props) =>
    props.$maxSize &&
    props.$minSize &&
    dynamicPx({ minSize: props.$minSize, maxSize: props.$maxSize })};

  position: relative;
  ${center}
  font-size: ${(props) =>
    props.$maxSize && props.$minSize ? 'var(--dynamic-px)' : props.fontSize};
  font-weight: 700;
  z-index: 1;
  color: #07080a;
  &::before,
  &::after {
    position: absolute;
    ${center}
    content: attr(data-text);
    -webkit-text-fill-color: white; /* Will override color (regardless of order) */
    -webkit-text-stroke-width: 0.2px;
    -webkit-text-stroke-color: rgba(0, 0, 0, 0.2);
  }
  &::before {
    bottom: 5px;
    z-index: -1;
  }
  &::after {
    bottom: 8px;
    z-index: -2;
  }
`;
